import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BiometricAuth = ({ onSuccess, onSkip }) => {
  const [isSupported, setIsSupported] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [authType, setAuthType] = useState('');

  useEffect(() => {
    // Check if biometric authentication is supported
    if (window.PublicKeyCredential && navigator.credentials) {
      setIsSupported(true);
      // Detect available authentication methods
      if (navigator.userAgent?.includes('iPhone') || navigator.userAgent?.includes('iPad')) {
        setAuthType('Face ID / Touch ID');
      } else if (navigator.userAgent?.includes('Android')) {
        setAuthType('Fingerprint / Face Unlock');
      } else {
        setAuthType('Windows Hello / Touch ID');
      }
    }
  }, []);

  const handleBiometricAuth = async () => {
    setIsLoading(true);
    
    try {
      // Simulate biometric authentication
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // In a real implementation, you would use WebAuthn API
      // const credential = await navigator.credentials.create({
      //   publicKey: {
      //     challenge: new Uint8Array(32),
      //     rp: { name: "TourEase" },
      //     user: {
      //       id: new Uint8Array(16),
      //       name: "user@example.com",
      //       displayName: "User"
      //     },
      //     pubKeyCredParams: [{ alg: -7, type: "public-key" }],
      //     authenticatorSelection: {
      //       authenticatorAttachment: "platform",
      //       userVerification: "required"
      //     }
      //   }
      // });
      
      onSuccess();
    } catch (error) {
      console.error('Biometric authentication failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isSupported) {
    return null;
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="text-center mb-8">
        <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Fingerprint" size={32} className="text-white" />
        </div>
        <h2 className="text-2xl font-bold text-foreground mb-2">Quick & Secure Access</h2>
        <p className="text-muted-foreground">
          Use {authType} for faster and more secure authentication
        </p>
      </div>

      <div className="space-y-4">
        <Button
          onClick={handleBiometricAuth}
          loading={isLoading}
          fullWidth
          className="h-14 text-lg"
          iconName="Fingerprint"
          iconPosition="left"
        >
          {isLoading ? 'Authenticating...' : `Use ${authType}`}
        </Button>

        <Button
          variant="outline"
          onClick={onSkip}
          fullWidth
          disabled={isLoading}
        >
          Use Password Instead
        </Button>
      </div>

      <div className="mt-8 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} className="text-primary mt-0.5" />
          <div className="text-xs text-muted-foreground">
            <p className="font-medium text-foreground mb-1">Enhanced Security</p>
            <p>
              Biometric authentication adds an extra layer of security to your account 
              while making sign-in faster and more convenient.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6 text-center">
        <p className="text-xs text-muted-foreground">
          Your biometric data is stored securely on your device and never shared with TourEase
        </p>
      </div>
    </div>
  );
};

export default BiometricAuth;